<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [additionalPhoneNumber]="additionalPhoneNumber"
  [heroCtaLabel]="heroCtaLabel"
  [heroCtaLink]="heroCtaLink"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Crédit Immobilier - Assurance Emprunteur</h2>
  </div>

  <!-- Intro Text -->
  <div class="intro-section">
    <h3>Faites près de 60% d'économies sur votre assurance de prêt :</h3>
    <p>
      Que vous ayez ou non déjà signé votre prêt, que la signature date de 24 heures ou 5 ans, grâce aux lois Lagarde, Hamon, Bourquin et depuis peu Lemoine, nous pouvons vous faire économiser plusieurs milliers d'euros sur la durée totale de votre prêt en souscrivant à nos assurance Crédit – Assurance Emprunteur. Il vous suffit de nous contacter ou de faire une simulation en ligne en cliquant sur le bouton ci-dessous et nous vous guiderons sur la démarche à suivre.
    </p>
    <p>
      Il faut savoir que les tarifs peuvent tout simplement doubler….selon différentes caractéristiques, comme votre âge, votre état de santé ou la durée du prêt.
    </p>
    <p>
      Nos conseillés BROKINS vous permettent d'optimiser vos recherches en comparant les contrats des leaders du marché de l'assurance de prêt tels que <strong class="text-purple">April, Utwin, Malakoff, Prévoir, Axa, Allianz, Metlife, Generali, Sphéria Vie, Afi Esca</strong>… Nous proposons ainsi plus de 40 références dans notre comparateur en ligne.
    </p>
    <p>
      Notre comparateur respecte l'équivalence de garanties, ce qui vous permet de trouver les contrats qui seront <strong class="highlight-purple">100% compatibles</strong> avec les exigences de votre banque. De plus, les contrats individuels permettent de souscrire à des garanties personnalisées, à la différence d'un contrat groupe (contrat de Banque), qui utilise la mutualisation des risques.
    </p>
    <p>
      Nous disposons de tous les assureurs réputés sur ce contrat d'assurance, dit assurance emprunteur comme par exemple : <strong class="text-purple">BNP CARDIF, APRIL, UTWIN, GENERALI, CNP, AXA, AXERIA, MALAKOFF HUMANIS, PREVOIR, METLIFE, AFI ESCA, ALPTIS, SWISSLIFE</strong>….
    </p>
  </div>

  <!-- Devis Button -->
  <div class="devis-button-section">
    <button class="btn-devis-large" (click)="navigateToDevis()">
      Devis en ligne
    </button>
  </div>

  <!-- Main Content -->
  <div class="content-section">
    <p>
      Avant d'accorder un prêt, les établissements de crédit exigent le plus souvent que leurs clients souscrivent une assurance emprunteur. Cette assurance a pour objet de garantir le remboursement du capital restant dû ou la prise en charge des mensualités en cas de maladie ou d'accident entrainant le décès ou l'arrêt de travail de l'assuré.
    </p>
    <p>
      Avec la baisse des taux d'intérêt, l'assurance de prêt pèse de plus en plus lourd dans le budget des emprunteurs et peut atteindre jusqu'à 40 % du coût total de l'emprunt. A ce prix-là, l'assuré a tout intérêt à vérifier qu'il paye pour des garanties efficaces…, ce qui, hélas, n'est pas toujours le cas.
    </p>
    <p>
      La plupart du temps, les particuliers adhèrent à l'assurance proposée par leur banque dans un souci de simplicité. L'opération crédit-assurance est alors dite liée mais elle n'est pas pour autant un gage de sécurité absolue pour les emprunteurs. Car comme toute police d'assurance, celle de l'établissement prêteur comporte des exclusions et des limites de garanties plus ou moins étendues selon les contrats.
    </p>
    <p>
      Cependant, les particuliers ne sont pas tenus de retenir l'assurance de leur banquier. Pour l'achat d'un bien immobilier, la loi leur permet de choisir leur contrat d'assurance emprunteur chez un organisme concurrent à condition que celui-ci respecte le niveau minimum de garanties exigé par l'établissement préteur.
    </p>
    <p>
      Depuis, le 26 juillet 2014, l'assuré-emprunteur dispose même d'un délai de 12 mois après la signature de l'offre de prêt pour changer de contrat d'assurance.
    </p>
    <p>
      Les particuliers doivent saisir cette opportunité pour trouver sur le marché une protection plus adaptée à leur mode de vie. Le prix ne doit pas à lui seul motiver le choix de l'assurance emprunteur, même si une assurance bien ciblée peut permettre de réaliser des économies importantes.
    </p>
    <p>
      Comparer les conditions générales des contrats d'assurance emprunteur n'est pas une partie de plaisir mais c'est pourtant une étape à ne pas négliger pour être sûr de ne pas avoir de mauvaises surprises en cas d'évènements difficiles. Pour cet exercice, l'aide d'un professionnel peut parfois apparaitre comme nécessaire.
    </p>
    <p>
      Pour faciliter le choix, voici les dix points auxquels il convient d'être vigilant avant de choisir son contrat d'assurance emprunteur.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">Les garanties proposées par le contrat d'assurance emprunteur :</h2>
    <p>
      Une assurance emprunteur est un contrat d'assurance temporaire dont la durée est calée sur celle du prêt. Elle couvre au minimum le remboursement du crédit ou la prise en charge des échéances en cas de décès de l'assuré. Elle intervient aussi lorsque l'assuré est reconnu en état d'invalidité ou d'incapacité. Sur ce type de garanties, les contrats se distinguent :
    </p>
    <ul class="guarantees-list">
      <li>la perte totale et irréversible d'autonomie ( PTIA ),</li>
      <li>l'Incapacité temporaire totale de travail,</li>
      <li>l'Invalidité permanente totale,</li>
      <li>l'Invalidité permanente partielle.</li>
    </ul>
    <p>
      Certains contrats peuvent prendre en charge sur le marché le risque d'incapacité temporaire de travail, mais ils sont peu nombreux.
    </p>
    <p>
      L' assurance emprunteur peut également prévoir une <strong class="text-purple">garantie perte d'emploi</strong> .
    </p>
    <p>
      Certains contrats d'assurance emprunteur proposent des garanties différentes et souvent plus adaptées pour certains professionnels, notamment les <strong class="text-purple">professionnels de santé</strong> .
    </p>
    <p>
      Contrairement à l'Assurance Prévoyance Décès dont vous trouverez plus d'informations ici, l'indemnisation de l'assurance de prêt est remise au bénéficiaire acceptant qui est la Banque. Ce n'est pas vous qui recevez l'indemnisation de l'assurance en cas d'invalidité.
    </p>
    <p>
      Il est très souvent conseillé de souscrire une <strong class="text-purple">Assurance Prévoyance GAV</strong>  (Garantie Accident de la Vie) dont vous trouverez plus d'informations ici, en plus de l'assurance de l'emprunteur, car le déclenchement de l'indemnisation de l'assureur commence à <strong class="highlight-purple">1 % d'invalidité, 5% d'invalidité, 10% d'invalidité</strong>. Pour l'assurance de prêt c'est plutôt <strong class="highlight-purple">33%</strong>.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">La définition des garanties en assurance emprunteur :</h2>
    <p>
      L'attention des particuliers doit porter en priorité sur les garanties invalidité, incapacité et la perte d'emploi.
    </p>
    <h3>Invalidité/incapacité : la question de l'activité professionnelle</h3>
    <p>
      L'invalidité permanente totale (IPT) et l'incapacité temporaire totale de travail (ITT) peuvent être définies par le contrat comme l'inaptitude pour l'assuré d'exercer :
    </p>
    <ul>
      <li>toute activité professionnelle</li>
      <li><strong>OU</strong></li>
      <li>son activité professionnelle</li>
    </ul>
    <p>
      Cette subtilité dans la rédaction est loin d'être neutre. Avec la clause d'exclusion « Toute activité professionnelle », l'assureur peut refuser sa garantie lorsqu'un emprunteur, après une maladie ou un accident, n'est plus en mesure de reprendre son ancien métier mais qu'il est reconnu capable d'en exercer un autre.
    </p>
    <p>
      La clause « Son activité professionnelle » assure une meilleure protection à l'assuré.
    </p>
    
    <div class="example-box">
      <h4>Exemple :</h4>
      <p>
        Un professionnel de la coiffure adhère à une assurance emprunteur afin de garantir le paiement de son prêt immobilier. Dans son contrat d'assurance, l'incapacité temporaire de travail est définie comme « l'inaptitude à exercer toute profession ». Lors d'un accident, il se blesse à la hanche et ne peut plus rester debout pendant de longs moments ce qui l'empêche d'exercer son métier de coiffeur. Pour lui refuser la garantie incapacité temporaire de travail de son contrat emprunteur, l'assureur lui signifie qu'il peut exercer un travail qui ne nécessite pas de rester debout de longues heures.
      </p>
    </div>

    <p>
      Les définitions de l'incapacité et de l'invalidité du contrat d'assurance emprunteur diffèrent généralement de celle de la Sécurité sociale. Cette dernière peut par exemple retenir un état d'incapacité pour l'assuré que l'assureur, de son côté, ne reconnaîtra pas.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">La définition de la garantie perte d'emploi :</h2>
    <p>
      Chaque organisme assureur définit dans son contrat ce qu'il entend par perte d'emploi. Bien souvent, il s'agit du licenciement de l'assuré-emprunteur ouvrant droit à une allocation chômage.
    </p>
    <p>Sont donc généralement exclus de la garantie perte d'emploi :</p>
    <ul>
      <li>la démission</li>
      <li>le licenciement pour faute lourde</li>
      <li>les périodes de travail trop courtes ne permettant pas d'être indemnisé par Pôle emploi</li>
    </ul>
    <p>
      Concernant la rupture conventionnelle, il convient de se reporter aux conditions générales du contrat dans la mesure où il ne s'agit pas d'un licenciement subi par l'assuré.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">La répartition de la quotité assurée en assurance emprunteur :</h2>
    <p>
      Un prêt peut être assuré en totalité ou partiellement. Dans un couple, il n'est pas rare que l'assurance soit souscrite en fonction des capacités financières de chaque co- emprunteurs. Cette situation permet de réduire le coût global des garanties emprunteurs. Attention cependant aux déconvenues lorsqu'il faut faire jouer le contrat.
    </p>
    <p>
      La quotité correspond à la part du prêt garantit par l'assurance en cas de sinistre. Elle s'exprime en pourcentage du montant du prêt et peut être différente selon les garanties.
    </p>
    <p>
      En cas d'emprunteur unique, la banque exige, dans la majorité des cas que l'assurance soit souscrite pour la totalité. On parle alors d'une quotité de <strong class="highlight-purple">100 %</strong>.
    </p>

    <div class="example-box">
      <h4>Exemple :</h4>
      <p>
        Pour un prêt de <strong class="highlight-purple">200 000 euros</strong>, une personne choisissant une quotité de 100 % sera couverte à hauteur de 200 000 euros (soit la totalité du capital emprunté).
      </p>
    </div>

    <p>
      La question de la quotité en assurance emprunteur se pose lorsqu'il y a plusieurs emprunteurs (on parle alors de co-emprunteurs). En effet, pour des co-emprunteurs, il est possible soit :
    </p>
    <ul>
      <li>de diviser entre les deux co-emprunteurs la quotité (par exemple pour la garantie décès 50 % de quotité pour chacun, pour la garantie incapacité temporaire totale de travail pendant toute la durée du prêt 40 % pour l'autre)</li>
      <li>d'opter pour une quotité de 100 % du prêt pour chaque co-emprunteur</li>
    </ul>

    <div class="example-box">
      <h4>Exemple :</h4>
      <p>
        Un couple signe un prêt pour un montant de <strong class="highlight-purple">150 000 euros</strong> garantis par un contrat d'assurance emprunteur. La quotité décès est répartie de la manière suivante : <strong class="highlight-purple">60 % pour Madame</strong> (soit 90 000 euros et <strong class="highlight-purple">40 % pour Monsieur</strong> (soit 60 000 euros). Si Monsieur décède de manière accidentelle, seulement 40 % du montant restant du prêt sera pris en charge par l'assureur. En revanche si le couple avait choisi une quotité de 100 % par personne, la totalité du montant du prêt aurait été pris en charge par l'assureur. En contrepartie les primes d'assurance auraient été plus importantes.
      </p>
    </div>

    <p>
      Pour le risque incapacité temporaire partielle de travail, lorsque celui-ci est couvert par l'assureur, il l'est souvent exclusivement dans le cadre d'un temps partiel thérapeutique à hauteur <strong class="highlight-purple">50 %</strong> de la quotité.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">La durée de couverture en assurance emprunteur :</h2>
    <p>
      Le contrat d'assurance peut prévoir des périodes à partir desquelles la garantie ou l'indemnisation cessent. L'assuré doit aussi être particulièrement attentif aux garanties incapacité et invalidité lorsqu'il est sans activité professionnelle.
    </p>
    
    <h3>La durée de la garantie :</h3>
    <p>
      Les garanties du contrat d'assurance emprunteur (décès, PTIA, invalidité, incapacité, perte d'emploi) peuvent couvrir l'assuré-emprunteur :
    </p>
    <ul>
      <li>pendant toute la durée du prêt</li>
      <li><strong>OU</strong></li>
      <li>cesser à partir d'un âge déterminé au contrat souvent compris entre <strong class="highlight-purple">65 et 75 ans</strong></li>
    </ul>

    <h3>Le maintien des garanties invalidité et incapacité sans activité professionnelle :</h3>
    <p>
      La durée d'un crédit immobilier peut être longue. Pendant la phase de remboursement, l'emprunteur peut faire face à des changements dans sa vie personnelle et des évolutions professionnelles. Il est important de bien étudier ce qui est prévu par le contrat en cas d'arrêt d'activité professionnelle, totale ou temporaire.
    </p>
    <p>
      Certains contrats prévoient la perte de la couverture pour les garanties invalidité et incapacité en cas d'absence d'activité professionnelle au moment de la réalisation du sinistre (maladie ou accident). Cela peut poser des problèmes pour une personne temporairement sans activité rémunérée et qui se retrouve en état d'invalidité ou d'incapacité avant la reprise d'un travail.
    </p>

    <div class="example-box">
      <h4>Exemple :</h4>
      <p>
        Un emprunteur a souscrit une assurance dont les conditions générales prévoient la suspension de la garantie incapacité temporaire totale de travail en cas d'inactivité. L'emprunteur démissionne et signe un nouveau contrat de travail prenant effet dans <strong class="highlight-purple">3 mois</strong>. Dans l'intervalle, l'emprunteur se blesse et ne peut pas rejoindre son nouveau poste à la date prévue. La garantie incapacité temporaire de travail totale étant suspendue l'emprunteur ne peut pas bénéficier du remboursement des échéances de son prêt.
      </p>
    </div>

    <h3>La durée d'indemnisation :</h3>
    <p>
      Le contrat d'assurance emprunteur peut prévoir une durée d'indemnisation au-delà de laquelle le contrat ne couvre plus l'assuré. Cette durée d'indemnisation peut être totale ou par sinistre.
    </p>
    <p>
      On retrouve généralement cette limite d'indemnisation pour la garantie perte d'emploi, lorsqu'elle figure au contrat.
    </p>
    <p>
      La durée d'indemnisation en perte d'emploi est, la plupart du temps, fixée entre <strong class="highlight-purple">12 et 24 mois</strong> par sinistre pour un totale de <strong class="highlight-purple">36 mois</strong> au maximum.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">Les garanties forfaitaire ou indemnitaire en assurance emprunteur :</h2>
    <p>
      Selon le contrat d'assurance emprunteur les garanties PTIA, invalidité, incapacité et perte d'emploi peuvent être forfaitaires ou indemnitaires.
    </p>
    <p>
      Une garantie forfaitaire est une garantie qui, en cas de sinistre, prend en charge l'intégralité de la mensualité assurée de remboursement du prêt sans référence à la perte de revenu subie pendant le sinistre.
    </p>
    <p>
      A l'inverse une garantie indemnitaire limite la prise en charge de l'assureur à la perte de revenu réellement subie par l'emprunteur. Si l'assuré perçoit une indemnité de la Sécurité sociale et/ou perçoit d'autres prestations en provenance d'autres contrats d'assurance de prévoyance de même nature, il ne sera pris en charge qu'après déductions de ces sommes.
    </p>

    <div class="example-box">
      <h4>Exemple :</h4>
      <p>
        Un assuré souscrit une assurance emprunteur comportant une garantie de type indemnitaire. Reconnu en invalidité permanente partielle supérieure à <strong class="highlight-purple">33 %</strong> à la suite d'un accident, il perçoit des indemnités de la Sécurité sociale et de son assureur auprès duquel il avait souscrit une assurance contre les maladies et accidents corporels. Les montants perçus couvrent <strong class="highlight-purple">60 %</strong> du montant des échéances du prêt. Dans ces conditions, l'assurance emprunteur prendra en charge la différence, soit <strong class="highlight-purple">40 %</strong> des mensualités.
      </p>
    </div>

    <p>
      Une garantie forfaitaire aurait pris en charge la totalité de la mensualité sans tenir compte des garanties et prestations existantes par ailleurs. Elle est donc plus protectrice pour l'assuré mais en toute logique, elle sera plus chère.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">Les exclusions de garanties en assurance emprunteur :</h2>
    <p>
      Les contrats d'assurance emprunteur comportent un certain nombre d'exclusions de garanties.
    </p>
    <p>
      Conformément à la loi, les exclusions de garanties doivent être rédigées en des termes clairs, précis et ne pas être sujettes à interprétation.
    </p>
    <p>
      Ces clauses d'exclusions doivent également figurer dans la police d'assurance en caractère très apparents (par exemple : en gras et dans une autre couleur que le reste du texte). Mais encore faut-il prendre le temps de les lire et ne pas hésiter à se les faire expliquer.
    </p>
    <p>
      Au-delà des cas classiques d'exclusions pour cause de guerre étrangère ou civile d'émeutes ou de mouvements populaires, l'emprunteur doit absolument être attentif aux exclusions conventionnelles qui diffèrent selon les contrats comme :
    </p>
    <ul>
      <li>des sports amateurs pratiqués par l'emprunteur</li>
      <li>des déplacements dans le monde entier à titre personnel et/ ou à titre professionnel ou humanitaire</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">La couverture du mal de dos et des affections psychologiques :</h2>
    <p>
      Affections psychiques, dépressions nerveuses, mal de dos, cela n'arrive pas qu'aux autres. Là encore, il convient d'être attentif car les contrats d'assurance emprunteurs qui prévoient, sans conditions, l'application des garanties invalidité et incapacité pour les affections psychiques et les problèmes de dos sont peu nombreux.
    </p>
    <p>
      Ces risques pour l'assureur sont appelés les <strong class="text-purple">maladies non-objectivables</strong>.
    </p>
    <p>
      La grande majorité des contrats d'assurance emprunteur excluent la couverture de ces maladies sauf si ces dernières ont donné lieu à :
    </p>
    <ul>
      <li>une hospitalisation d'une certaine durée (souvent supérieure à <strong class="highlight-purple">10 jours</strong>)</li>
      <li><strong>OU</strong></li>
      <li>une intervention chirurgicale</li>
    </ul>
    <p>
      On retrouve généralement cette limite d'indemnisation pour la garantie perte d'emploi, lorsqu'elle figure au contrat.
    </p>
    <p>
      La durée d'indemnisation en perte d'emploi est, la plupart du temps, fixée entre <strong class="highlight-purple">12 et 24 mois</strong> par sinistre pour un totale de <strong class="highlight-purple">36 mois</strong> au maximum.
    </p>
    <p>
      Hors de ces cas de figure, l'assuré ne reçoit aucune indemnisation.
    </p>
    <p>
      Certains contrats d'assurance emprunteur prévoient des options supplémentaires qui, moyennant une hausse de tarif, prennent en charge les échéances du prêt en cas d'incapacité ou d'invalidité liées à des maladies non-objectivables.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">Le plafond de garantie en assurance emprunteur :</h2>
    <p>
      Le plafond de garantie correspond à un montant maximal d'indemnisation au titre de la garantie emprunteur. Ce plafond peut être fixé :
    </p>
    <ul>
      <li>par année d'assurance</li>
      <li>par sinistre</li>
    </ul>
    <p>
      Des plafonds de garanties peuvent être fixés pour l'ensemble des garanties (décès, incapacité, invalidité, et perte d'emploi) ou pour une ou plusieurs garanties au choix de l'assureur.
    </p>

    <div class="example-box">
      <h4>Exemple :</h4>
      <p>
        Un contrat emprunteur prévoit une prise en charge à hauteur de <strong class="highlight-purple">10 000 euros</strong> par sinistre pour la garantie incapacité temporaire totale de travail. Si le montant du sinistre est égal à <strong class="highlight-purple">5 000 euros</strong> l'assureur indemne l'assuré à hauteur de 5 000 euros. Si le montant du sinistre est égal à <strong class="highlight-purple">20 000 euros</strong>, l'assureur limite son indemnisation à hauteur de 10 000 euros.
      </p>
    </div>
  </div>

  <div class="content-section">
    <h2 class="purple-title">La franchise en assurance emprunteur :</h2>
    <p>
      Le contrat d'assurance emprunteur peut prévoir une franchise.
    </p>
    <p>
      La franchise correspondant à la période, exprimée en jours, de non-indemnisation par l'assurance. Elle est applicable pendant toute la durée du contrat.
    </p>

    <div class="example-box">
      <h4>Exemple :</h4>
      <p>
        Un particulier souscrit une assurance emprunteur pour un prêt immobilier contracté auprès de sa banque. A la suite d'un accident, le <strong class="highlight-purple">10 avril 2017</strong>, il se retrouve en incapacité temporaire totale de travail jusqu'au <strong class="highlight-purple">31 octobre 2017</strong>. Son contrat prévoit une franchise de <strong class="highlight-purple">90 jours</strong>. L'assurance emprunteur prendra en charge les échéances de son prêt immobilier à compter du <strong class="highlight-purple">10 juillet</strong> jusqu'au 31 octobre 2017.
      </p>
    </div>

    <p>
      Les franchises concernent généralement les garanties incapacité et perte d'emploi.
    </p>
    <ul>
      <li>pour l'incapacité ces franchises sont souvent comprises entre <strong class="highlight-purple">30 et 180 jours</strong> (<strong class="highlight-purple">90 jours</strong> en moyenne)</li>
      <li>pour la perte d'emploi le délai de franchise oscille fréquemment entre <strong class="highlight-purple">40 et 120 jours</strong>.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">Le délai de carence en assurance emprunteur :</h2>
    <p>
      Le délai de carence à la différence de la franchise, s'applique uniquement en début de contrat d'assurance. Il correspond à la période de latence suivant immédiatement la souscription ou l'adhésion de l'emprunteur au contrat. Lorsqu'un sinistre intervient durant cette période, l'assuré n'est pas garanti.
    </p>
    <p>
      <strong>Pour la garantie décès :</strong> La loi prévoit un délai de carence en cas de suicide de l'assuré au cours de la première année du contrat emprunteur.
    </p>
    <p>
      Ce délai de carence ne s'applique pas dans le cadre de l'achat d'une résidence principale pour un contrat d'assurance emprunteur ouvert auprès de la banque ayant accordé le prêt. Dans cette hypothèse, la couverture du suicide est due dès la 1ère année dans la limite de <strong class="highlight-purple">120 000 euros</strong>.
    </p>
    <p>
      <strong>Pour la garantie perte d'emploi :</strong> le contrat d'assurance emprunteur prévoit généralement un délai de carence de <strong class="highlight-purple">3 à 12 mois</strong>.
    </p>
  </div>

  <!-- Bottom Devis Button -->
  <div class="devis-button-section">
    <button class="btn-devis-large" (click)="navigateToDevis()">
      Devis en ligne
    </button>
  </div>

</app-page-layout>

